/* import Global */
import { app } from './config/app/app'
import store from './store/'
import Tippy from './utils/tippy'
// import 'vue-svgicon/dist/polyfill'
import '@/utils/modernizr-custom' // global
import '@/config/app/directives'
import '@/config/app/ZComponents'
import '@/config/prod/components'
import '@/config/prod/views'
const Emitter = require('tiny-emitter')
const emitter = new Emitter()

app.config.globalProperties.emitter = emitter;

app.use(store)
app.use(Tippy)

app.mount('#app')
